import type { RoleDto } from "common/models/api/models/RoleDto";
import { RoleTypes } from "ui/user/user.types";

export default class ResourceInfo {
    name: string;
    image: string;

    constructor(name: string, image: string) {
        this.name = name;
        this.image = image;
    }

    static fromRole(role: RoleDto): ResourceInfo {
        const organizationName = role?.organization?.name as string;
        const organizationImage = role?.organization?.image as string;
        const programName = role?.program?.name as string;
        const programLogo = role?.program?.logo as string;
        const partnerName = role?.partner?.name as string;
        const partnerLogo = role?.partner?.logo as string;

        switch (role.roleType) {
            case RoleTypes.ORGANIZATION_OWNER:
                return new ResourceInfo(organizationName, organizationImage);
            case RoleTypes.OPERATION_MANAGER:
                return new ResourceInfo("Admin Operaciones", "");
            case RoleTypes.CUSTOMER_SERVICE:
                return new ResourceInfo("Admin Servicio al cliente", "");
            case RoleTypes.PROGRAM_MANAGER:
                return new ResourceInfo(programName, programLogo);
            case RoleTypes.PARTNER:
                return new ResourceInfo(partnerName, partnerLogo);
            default:
                return new ResourceInfo(organizationName, organizationImage);
        }
    }
}
